var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPremiumBadge = function SvgPremiumBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 17,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 16,
    y: 0.5,
    fill: "#FFF5E6",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFBF00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M18.438 12.863h-5.875a.737.737 0 0 1-.644-.457L9.33 5.17c-.368-1.038.063-1.357.95-.719l2.438 1.744c.406.281.869.137 1.043-.319l1.1-2.931c.35-.938.932-.938 1.282 0l1.1 2.931c.175.456.637.6 1.037.319l2.288-1.632c.975-.7 1.444-.343 1.044.788l-2.526 7.069a.763.763 0 0 1-.65.444Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFBF00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.063 14.75h6.874M13.938 9.75h3.124",
    opacity: 0.34
  })));
};
export default SvgPremiumBadge;